module.exports = __webpack_public_path__ + "img/nine_.8a353949.png";